import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ImpressumDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="impressum-dialog"
        className="max-w-2xl bg-card border-border max-h-[85vh] overflow-y-auto"
      >
        <DialogHeader>
          <DialogTitle className="text-xl">Impressum</DialogTitle>
          <DialogDescription>
            Angaben gemäß § 5 TMG
          </DialogDescription>
        </DialogHeader>

        <div className="text-sm text-foreground space-y-6 mt-2">
          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Anbieter
            </h3>
            <div className="space-y-0.5">
              <div className="font-semibold text-base">Xortec GmbH</div>
              <div className="flex items-start gap-2 text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
                <span>
                  Berner Str. 79
                  <br />
                  60437 Frankfurt am Main
                  <br />
                  Deutschland
                </span>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Kontakt
            </h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-primary" />
                <a
                  href="tel:+496950698860"
                  className="text-foreground hover:text-primary"
                >
                  +49 69 5069886-0
                </a>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <span className="w-4 h-4 inline-flex items-center justify-center text-primary text-[10px] font-bold">FAX</span>
                <span>+49 69 5069886-29</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-primary" />
                <a
                  href="mailto:info@xortec.de"
                  className="text-foreground hover:text-primary"
                >
                  info@xortec.de
                </a>
              </div>
              <div className="flex items-center gap-2">
                <ExternalLink className="w-4 h-4 text-primary" />
                <a
                  href="https://xortec.de"
                  target="_blank"
                  rel="noreferrer"
                  className="text-foreground hover:text-primary"
                >
                  www.xortec.de
                </a>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Geschäftsführer
            </h3>
            <p className="text-foreground">Michael Schaller</p>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Eintragung im Handelsregister
            </h3>
            <div className="text-muted-foreground space-y-0.5">
              <div>Registergericht: Amtsgericht Frankfurt am Main</div>
              <div>Registernummer: HRB 79237</div>
            </div>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Umsatzsteuer-Identifikationsnummer
            </h3>
            <p className="text-muted-foreground">
              gemäß § 27 a Umsatzsteuergesetz: <span className="text-foreground font-mono">DE252844047</span>
            </p>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              WEEE-Reg.-Nr.
            </h3>
            <p className="text-muted-foreground font-mono">DE 52527592</p>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Verantwortlich für den Inhalt
            </h3>
            <p className="text-muted-foreground">
              Xortec GmbH, Berner Str. 79, 60437 Frankfurt am Main
            </p>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Haftungshinweis
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Der Milestone XProtect Auswahlassistent ist eine unverbindliche
              Entscheidungshilfe. Die Empfehlungen basieren auf den offiziellen
              Vergleichsdaten von Milestone Systems und den Angaben des Nutzers.
              Für die konkrete Projektumsetzung ist eine individuelle Beratung
              durch die Xortec GmbH oder einen zertifizierten
              Milestone-Partner erforderlich. Alle Marken und Produktnamen sind
              Eigentum ihrer jeweiligen Inhaber.
            </p>
          </section>

          <section>
            <h3 className="text-primary text-xs uppercase tracking-widest font-semibold mb-2">
              Weiterführende Informationen
            </h3>
            <div className="flex flex-wrap gap-2">
              <Button asChild size="sm" variant="outline">
                <a
                  href="https://xortec.de/Rechtliches/Impressum/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Vollständiges Impressum{" "}
                  <ExternalLink className="w-3.5 h-3.5 ml-1.5" />
                </a>
              </Button>
              <Button asChild size="sm" variant="outline">
                <a
                  href="https://xortec.de/Rechtliches/AGB/"
                  target="_blank"
                  rel="noreferrer"
                >
                  AGB{" "}
                  <ExternalLink className="w-3.5 h-3.5 ml-1.5" />
                </a>
              </Button>
              <Button asChild size="sm" variant="outline">
                <a
                  href="https://xortec.de/Rechtliches/Datenschutz/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Datenschutz{" "}
                  <ExternalLink className="w-3.5 h-3.5 ml-1.5" />
                </a>
              </Button>
            </div>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  );
}
